module.exports = __webpack_public_path__ + "static/media/sara_alves.4734fcd8.jpg";